import { render, staticRenderFns } from "./Nawin.vue?vue&type=template&id=1eaf9086&scoped=true&"
import script from "./Nawin.vue?vue&type=script&lang=js&"
export * from "./Nawin.vue?vue&type=script&lang=js&"
import style0 from "./Nawin.vue?vue&type=style&index=0&id=1eaf9086&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eaf9086",
  null
  
)

export default component.exports